import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgResetIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 17,
	viewBox: "0 0 23 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M13 19.5C18.25 19.5 22.5 15.25 22.5 10C22.5 4.75 18.25 0.5 13 0.5C7.75 0.5 3.5 4.75 3.5 10V11.49",
		fill: "transparent",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		stroke: "#7284FA",
		strokeWidth: 1.25
	}), /* @__PURE__ */ _jsx("path", {
		d: "M0.5 6.98999L3.5 11.49L7 7.48999",
		fill: "#DAD9EF",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		stroke: "#7284FA",
		strokeWidth: 1.25
	})]
});
export default SvgResetIcon;
